<template>
  <div>
    <SectionTitle>
      <h5>Cursos em progresso</h5></SectionTitle>

    <UserProfileCoursesIndex :user="user">
      <template v-slot="{ courses, isLoading }">
        <UserProfileCoursesList :courses="courses"/>

        <div 
          v-if="courses.length >= 5"
          class="text-center pt-4 pb-4"
          @click="showUserCourses"
        >
          <SecondaryButton>ver todos os cursos</SecondaryButton>
        </div>
      </template>
    </UserProfileCoursesIndex>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SectionTitle from '@/components/text/titles/SectionTitle'
import UserProfileCoursesList from './UserProfileCoursesList.vue'
import SecondaryButton from '@/components/buttons/SecondaryButton.vue'
import UserProfileCoursesIndex from '@/components/user/profile/UserProfileCoursesIndex'

export default {
  components: {
    SectionTitle,
    UserProfileCoursesList,
    SecondaryButton,
    UserProfileCoursesIndex,
  },

  props: {
    user: { type: Object, required: true }
  },

  methods: {
    ...mapActions('slideSidebar', ['slideSidebarShow']),

    showUserCourses () {
      this.slideSidebarShow({
        name: 'user/UserCoursesOngoingSidebar',
        direction: 'right',
        props: { user: this.user }
      })
    }
  }
}
</script>